import React from 'react'
import PropTypes from 'prop-types'

import Select from 'coact/Select'


function SelectCondition (props) {
  const { linkState, schema, style } = props
  return (
    <div className={style.searchWidget}>
      <div className={style['ref-container']}>
        <Select
          schema={schema}
          {...linkState('selected')}
        />
      </div>
    </div>
  )
}

const { func, object } = PropTypes
SelectCondition.propTypes = {
  linkState: func.isRequired,
  schema: object.isRequired,
  style: object.isRequired,
}

SelectCondition.buildQuery = function buildSelectQuery ({ selected }) {
  if (!selected) return null
  return { $eq: selected }
}


export default SelectCondition



// WEBPACK FOOTER //
// ./src/components/SalesOrderReport/SingleSelectCondition.jsx